import type { Locale } from "@/kernel/locale";

// Fills {name} placeholders of a translated message. Numbers are formatted for
// the locale; an unknown placeholder stays visible so a wrong call is noticed.
// Environment-neutral: the server translator and client components use it.

export type MessageParams = Record<string, string | number>;

const PLACEHOLDER = /\{([A-Za-z0-9_]+)\}/g;

const numberFormats = new Map<string, Intl.NumberFormat>();

function formatNumber(locale: Locale, value: number): string {
  let format = numberFormats.get(locale);
  if (!format) {
    format = new Intl.NumberFormat(locale);
    numberFormats.set(locale, format);
  }
  return format.format(value);
}

export function formatMessage(message: string, params: MessageParams, locale: Locale): string {
  return message.replace(PLACEHOLDER, (placeholder, name: string) => {
    if (!Object.hasOwn(params, name)) return placeholder;
    const value = params[name];
    return typeof value === "number" ? formatNumber(locale, value) : value;
  });
}
